//引入vue
import Vue from 'vue';
//引入vue-router
import VueRouter from 'vue-router';
import landingPage from "@/components/LandingPage";
import WarrantyPage from "@/components/WarrantyPage";
import FinishedPage from "@/components/FinishedPage";
//第三方库需要use一下才能用
Vue.use(VueRouter)
const routes = [
    { path: "/", component: landingPage },
    { path: "/warranty/:lang", component: WarrantyPage },
    { path: "/finished", component: FinishedPage },
]

const router = new VueRouter({
    routes
});


/*router.beforeEach((to, from, next) => {
    Vue.prototype.$bus.$emit("closeMsg");

    // 路由变化时取消当前所有非全局的pending状态的请求
    Vue.prototype.$axios.clearPendingPool();
    if (to.path !== "/login" && !localStorage.token) {
        next({path: "/login"});
    } else {
        next();
    }
});*/


export default router;